module.exports = __webpack_public_path__ + "static/media/IKMS07.a29aad27.jpg";